var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg pa-2 pb-5 white",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"secondary--text"},[_vm._v(" نمودار هزینه ها "),_c('v-spacer'),_c('chart-export-btn',{attrs:{"page-chart-id":"cost-chart"}})],1),_c('canvas',{attrs:{"height":"120","id":"cost-chart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }